import { data } from '../../svg/PauseCircle/data';
import { makeIcon } from '../makeIcon';

export const PauseCircle = makeIcon(data, 'pause_circle', 'PauseCircle');

export default PauseCircle;
